import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import Badge from '@segment/matcha/components/Badge'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import ButtonText from '@segment/matcha/components/ButtonText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import CardBase, * as Card from '@segment/matcha/recipes/Card'

import { usePageConfig } from '@segment/contexts/page'

import getResources from './data'

const copy = {
  heading: `Resources`,
}

const Resources = () => {
  const pageConfig = usePageConfig()
  const data = getResources(pageConfig)
  return (
    <Wrapper>
      <SectionBase variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <StyledColumns columns={1} overrides={{ md: 3 }}>
            {data.map(({ title, description, badge, buttonText, buttonUrl }) => (
              <CardBase key={title} href={buttonUrl}>
                <Card.Body>
                  <Card.Accessories>
                    <Card.AccessoriesRow>
                      <Badge tag="span" variant="outlined">
                        {badge}
                      </Badge>
                    </Card.AccessoriesRow>
                  </Card.Accessories>
                  <Card.Copy>
                    <Card.Headline>{title}</Card.Headline>
                    <Card.Description>{description}</Card.Description>
                  </Card.Copy>
                  <Card.Action>
                    <ButtonText tag="span" iconEnd={ChevronRightIcon}>
                      {buttonText}
                    </ButtonText>
                  </Card.Action>
                </Card.Body>
              </CardBase>
            ))}
          </StyledColumns>
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledColumns = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
`

export default Resources
